<template>
  <div v-if="customerServiceDialogVisible" class="dialog-customer-service">
    <i class="el-icon-close" @click="onClickCloseIcon"></i>
    <iframe
      :src="customerServiceURL"
      title="customer service"
      scrolling="no"
      class="dialog-customer-service__iframe"
    ></iframe>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "DialogCustomerService",
  data() {
    return {
      customerServiceURL:
        "https://im1c5366d.7x24cc.com/phone_webChat.html?accountId=N000000034043&chatId=b7bf2280-4282-49e3-8b62-51381f72d595",
    };
  },
  computed: {
    ...mapState(["customerServiceDialogVisible"]),
  },
  methods: {
    ...mapMutations(["setCustomerServiceDialogVisible"]),

    onClickCloseIcon() {
      this.setCustomerServiceDialogVisible(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-customer-service {
  position: fixed;
  top: 50%;
  right: 2vw;
  width: 320px;
  height: 560px;
  border-radius: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: translate(0, -50%);

  .el-icon-close {
    position: absolute;
    top: 16px;
    right: 16px;
    color: #fff;
    cursor: pointer;
  }

  .dialog-customer-service__iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>